import { createFileRoute } from '@tanstack/react-router';

import Icon from '@/components/Icon/Icon';
import { Spacer, VStack } from '@/components/Layout';
import { Text } from '@/components/Typography/Text';
import { defaultNS, useTranslation } from '@/lib/i18n';

export const Route = createFileRoute('/_staff/marketplace/unavailable/')({
  component: MarketplaceUnavailable,
});

function MarketplaceUnavailable() {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: 'pages.marketplace',
  });

  return (
    <div className="flex h-[50vh] items-center justify-center">
      <VStack className="items-center text-center">
        <Icon
          iconName="TriangleAlertIcon"
          className="size-10 stroke-2 text-destructive"
        />
        <Spacer variant="xs" />
        <Text variant="h3">{t('marketplaceUnavailable')}</Text>
        <Spacer variant="xxs" />
        <Text variant="pSmall" className="text-muted-foreground">
          {t('marketplaceUnavailableDescription')}
        </Text>
      </VStack>
    </div>
  );
}
